import React from 'react';
import colors from '../../utils/colors';
import ToggleSwitch from './ToggleSwitch';
import { translate } from '../../utils/translationManager';
import { useLanguage } from '../../context/LanguageContext';

const LayerSidebar = ({ toggleLayer, isLayerVisible, header, layersData }) => {
  const { language } = useLanguage();

  // Group layers by category
  const groupedLayers = layersData.reduce((groups, layer) => {
    const category = layer.category;
    if (!groups[category]) {
      groups[category] = [];
    }
    groups[category].push(layer);
    return groups;
  }, {});

  return (
    <div
      style={{
        padding: '20px',
        backgroundColor: colors.backgroundContainer,
        borderRadius: '15px',
        boxShadow: '0px 10px 20px rgba(0, 0, 0, 0.1)',
        maxWidth: '100%',
        width: '90%',
        margin: '30px auto 0'
      }}
    >
      {header && (
        <div
          style={{
            fontWeight: 'bold',
            fontSize: '20px',
            marginBottom: '20px',
            color: colors.headerText
          }}
        >
          {header}
        </div>
      )}

      {Object.entries(groupedLayers).map(([category, layers], groupIndex) => (
        <div key={groupIndex}>
          {/* Category heading */}
          <div
            style={{
              fontWeight: 'bold',
              fontSize: '18px',
              marginBottom: '10px',
              marginTop: groupIndex !== 0 ? '20px' : '0',
              borderBottom: '2px solid black', // Black border at the bottom
              paddingBottom: '5px', // Space between text and border
              color: colors.subHeaderText
            }}
          >
            {category}
          </div>

          {/* Layer toggles */}
          {layers.map((layer, index) => (
            <ToggleSwitch
              key={index}
              isLayerVisible={layer.isLayerVisible[0]}
              toggleLayer={toggleLayer}
              layerName={layer.layerName}
              label={translate(layer.layerLabel, language)}
            />
          ))}

          {/* Separator */}
          {groupIndex !== Object.entries(groupedLayers).length - 1 && (
            <hr
              style={{
                border: 'none',
                borderTop: `1px solid ${colors.separator}`,
                margin: '20px 0'
              }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default LayerSidebar;
